// ✅ AccountDashboardController.js
import { useEffect, useState, useRef } from "react";
import { getData, postData } from "../../ApiServices/ApiService";
// import { EXPENSE_DASHBOARD_URL, ORG_GET_ALL_CODES_LIST } from "../../ApiServices/BaseURL";

const AccountDashboardController = () => {

  const [showModal, setShowModal] = useState(false);
  const expenseInfoRef = useRef(null);
  const openModal = () => {
    expenseInfoRef.current = null;
    setShowModal(true);
  }

  return {
    showModal,
    openModal,
    closeModal: () => setShowModal(false),
    expenseInfoRef,
  };
};

export default AccountDashboardController;